import { fieldTypes, SchemaFactoryV2 } from "@ucl/library";
import { FC } from "react";
import {
  TaskExecutionTemplateFieldsComponent,
  TaskExecutionTypeFieldSets,
} from "./TaskExecutionTemplateFieldsComponent";

export interface TaskExecutionTypeComponentValue {
  key: string;
  taskExecutionType: string;
  entityType: string;
  factory: SchemaFactoryV2;
  fieldSet: TaskExecutionTypeFieldSets;
  getAuthRequestHeader: () => Promise<Record<string, string> | undefined>;
  apiBaseUrl: string;
  errors?: { [key: string]: string[] };
  isReadOnly?: boolean;
}

export interface TaskExecutionTypeComponentProps
  extends fieldTypes.BaseFieldProps<Record<string, any>> {}
export const TaskExecutionTypeComponent: FC<TaskExecutionTypeComponentProps> = (
  props
) => {
  const taskExecutionTypeComponentValue =
    props.complexFieldValue as TaskExecutionTypeComponentValue;

  if (!taskExecutionTypeComponentValue?.taskExecutionType) {
    return null;
  }

  return (
    <div className="task-execution-type-component">
      <TaskExecutionTemplateFieldsComponent
        key={taskExecutionTypeComponentValue.key}
        taskExecutionType={taskExecutionTypeComponentValue.taskExecutionType}
        entityType={taskExecutionTypeComponentValue.entityType}
        fieldSet={taskExecutionTypeComponentValue.fieldSet}
        taskExecutionTypeData={props.value}
        factory={taskExecutionTypeComponentValue.factory}
        getAuthRequestHeader={
          taskExecutionTypeComponentValue.getAuthRequestHeader
        }
        apiBaseUrl={taskExecutionTypeComponentValue.apiBaseUrl}
        errors={taskExecutionTypeComponentValue.errors}
        updateTaskExecutionTypeData={(updatedModel) => {
          const newTaskExecutionTypeComponentValue = {
            ...props.value,
            ...updatedModel,
          };
          props.onSubmit?.(newTaskExecutionTypeComponentValue);
        }}
        isReadOnly={taskExecutionTypeComponentValue.isReadOnly}
      />
    </div>
  );
};
